// MARK://dhk8/pos/features/env/SandboxBanner
// Persistent slim full-width bar at the top of the content area (under the
// topbar, like TrainingBanner) shown whenever the active env is 'test'. It says
// plainly that ventas here don't count. Tenant-env — NOT per-session training,
// so it coexists with TrainingBanner (training can be on inside test or live).
//
// Renders nothing in 'live'. Themed via --pos-* tokens (dark + light), warning
// tint like TrainingBanner but visually distinct (tinted standing band + left
// accent rule, no exit button — you leave the sandbox from the env-switcher /
// admin, not from here). Collapses cleanly at 375px: the label truncates.

import { FlaskConical } from 'lucide-react'

import { useAuthStore } from '../../stores/auth-store.js'
import { t } from '../../i18n/es-MX.js'

export default function SandboxBanner() {
  const activeEnv = useAuthStore((s) => s.activeEnv)
  if (activeEnv !== 'test') return null

  return (
    <div className="pos-sandbox-banner" role="status" aria-live="polite">
      <FlaskConical size={18} aria-hidden className="pos-sandbox-banner__icon" />
      <span className="pos-sandbox-banner__text">{t('env.bannerText')}</span>
      <style>{styles}</style>
    </div>
  )
}

const styles = `
  .pos-sandbox-banner {
    display: flex;
    align-items: center;
    gap: var(--pos-space-2);
    width: 100%;
    box-sizing: border-box;
    min-height: 36px;
    padding: var(--pos-space-1) var(--pos-space-3);
    margin-bottom: var(--pos-space-3);
    border-radius: var(--pos-radius-md);
    background: var(--pos-warning-bg);
    border: 1px solid color-mix(in oklch, var(--pos-warning) 35%, transparent);
    color: var(--pos-fg);
    font-family: var(--font-display, var(--font-sans));
    font-size: var(--pos-text-xs);
    font-weight: var(--pos-weight-semibold);
    letter-spacing: var(--pos-tracking-snug);
    user-select: none;
  }
  .pos-sandbox-banner__icon { flex: none; color: var(--pos-warning); }
  .pos-sandbox-banner__text {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  @media (max-width: 520px) {
    .pos-sandbox-banner { font-size: var(--pos-text-xxs); }
  }
`
